export default __webpack_public_path__ + "static/partner7-6d5eb0d9b4ce091bc9ba1afcfc986008.jpg";